module.exports = function getResource(label, vars = []) {
    const resources = {
        storesAndServices: 'Stores & Services',
        home: 'Home',
        shop: 'Shop',
        offers: 'Offers',
        me: 'Me',
        signIn: 'Sign In',
        community: 'Community',
        stores: 'Stores',
        tooltip: 'Sign in (or sign up!) for offers, points, and more.'
    };
    return resources[label];
};
